export const COUPONS_TYPES = {
  exclusive: 'exclusive',
  coupon: 'coupon',
  sponsored: 'sponsored',
};
